import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { ThemeProvider } from 'styled-components';
import { AppFooterComponent } from './AppFooterComponent';
import { AppViewComponent } from './AppViewComponent';
import { ViewContainerWrapper } from './BasicViewContainer';
import { FramedAppHeader } from './FramedAppHeader';
import { useViewContainer } from './useViewContainer';
export const FramedViewContainer = () => {
  const {
    ViewComponent,
    viewContainerProps
  } = useViewContainer();

  if (!ViewComponent) {
    return null;
  }

  return /*#__PURE__*/_jsx(ThemeProvider, {
    theme: {
      embedded: true
    },
    children: /*#__PURE__*/_jsxs(ViewContainerWrapper, Object.assign({}, viewContainerProps, {
      children: [/*#__PURE__*/_jsx(FramedAppHeader, {}), /*#__PURE__*/_jsx(AppViewComponent, {
        StepViewComponent: ViewComponent
      }), /*#__PURE__*/_jsx(AppFooterComponent, {})]
    }))
  });
};